import React, { useState } from "react";
import "../../styles/audiobook/AudioBookSelectionModal.scss";
import { useLocation, useNavigate } from "react-router-dom";
import useAppTranslation from "../../hooks/useAppTranslation";

const AudioBookSelectionModal = ({
  audiobooks,
  onSelect,
  onClose,
  bookID,
  onReadTextBook,
  onDeleteSelected,
}) => {
  const { t } = useAppTranslation("components/audiobook/audioBookSelectionModal");
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteMode, setDeleteMode] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // /share 또는 /audio-share 경로인지 확인
  const isSharePage =
    location.pathname.includes("/share") ||
    location.pathname.includes("/audio-share");

  const getVoiceLabel = (voiceType) =>
    voiceType === "myvoice" ? t("voiceTypes.myvoice") : voiceType;

  const createDate = (fullDate) => fullDate.split("T")[0];

  const handleCheckboxChange = (audiobookId) => {
    setSelectedIds((prev) =>
      prev.includes(audiobookId)
        ? prev.filter((id) => id !== audiobookId)
        : [...prev, audiobookId],
    );
  };

  const handleDelete = () => {
    if (selectedIds.length === 0)
      return alert(t("alerts.selectDeleteTarget"));
    onDeleteSelected(selectedIds);
  };

  return (
    <div className="audio-modal-backdrop">
      <div className="audio-modal">
        {!isSharePage && (
          <button
            onClick={() => {
              setDeleteMode((prev) => !prev);
            }}
            className={`delete-mode-btn ${deleteMode ? "is-done" : "is-delete"}`}
            aria-label={
              deleteMode ? t("actions.exitDeleteMode") : t("actions.deleteMode")
            }
          >
            <img
              src={
                deleteMode ? "/images/audiobook/back.svg" : "/images/audiobook/trash.svg"
              }
              alt=""
            />
            <span>
              {deleteMode ? t("actions.exitDeleteMode") : t("actions.deleteMode")}
            </span>
          </button>
        )}
        <div className="audio-select-title">
          <h2>{deleteMode ? t("title.delete") : t("title.select")}</h2>
          <p>
            {deleteMode
              ? t("description.delete")
              : t("description.select")}
          </p>
        </div>
        {audiobooks.length === 0 ? (
          <div className="empty-audiobook">
            <p>{t("empty.message")}</p>
            <button onClick={onClose}>{t("actions.close")}</button>
            <button
              onClick={() => {
                navigate("/myStorybook");
              }}
            >
              {t("actions.makeAudioBook")}
            </button>
          </div>
        ) : (
          <ul className="audio-list">
            {audiobooks.map((audio) => (
              <li
                key={audio.audiobook_id}
                className={`audio-item ${
                  selectedIds.includes(audio.audiobook_id) ? "selected" : ""
                }`}
              >
                <label>
                  {deleteMode && (
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(audio.audiobook_id)}
                      onChange={() => handleCheckboxChange(audio.audiobook_id)}
                    />
                  )}
                  <span
                    onClick={() => {
                      if (!deleteMode) onSelect(audio.audiobook_id);
                    }}
                  >
                    <strong>[ {audio.audiobook_title} ]</strong>
                    <div className="audio-meta">
                      {/* 보이스타입 커스텀이면 바꾸기 */}
                      <span>{getVoiceLabel(audio.voice_type)}</span>
                      <span>{createDate(audio.created_date)}</span>
                    </div>
                  </span>
                </label>
              </li>
            ))}
          </ul>
        )}

        <div className="modal-buttons">
          {!deleteMode && (
            <button className="audio-close-btn" onClick={onClose}>
              <span className="button-icon close-icon" aria-hidden="true">
                <img src={"/images/audiobook/x.svg"} alt="" />
              </span>
              <span>{t("actions.close")}</span>
            </button>
          )}
          {!deleteMode && (
            <button
              className="audio-read-btn"
              onClick={() => onReadTextBook(bookID)}
            >
              <span className="button-icon book-icon" aria-hidden="true">
                <img src={"/images/audiobook/book.svg"} alt="" />
              </span>
              <span>{t("actions.readCasually")}</span>
            </button>
          )}

          {deleteMode && (
            <button onClick={handleDelete} className="delete-audio-btn">
              <img src={"/images/audiobook/trash.svg"} alt="" />
              <span>{t("actions.deleteAudioBook")}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AudioBookSelectionModal;
